<template>
  <div id="app">
    <router-view></router-view>
  </div>
</template>

<script>
export default {
  name: 'App',
  created() {
    // if (this.$route.query.lang) {
    //   if (this.$route.query.lang == 'zh-Hant' || this.$route.query.lang == 'pt')
    //     localStorage.setItem('lan', this.$route.query.lang);
    //   this.$i18n.locale = `'zh-Hant'`;
    // } else {
    //   this.$i18n.locale = localStorage.getItem('lan')
    //     ? localStorage.getItem('lan')
    //     : 'zh-Hant';
    // }
     this.$i18n.locale = `'zh-Hant'`;
  },
  mounted() {
    document.title = this.$t('Common.title.homeTitle');
    window.onresize = () => {
      this.$store.commit("window/changeWidth", document.body.clientWidth);
      this.$store.commit("window/changeHeight", document.body.clientHeight);
    };

    this.$store.commit("window/changeWidth", document.body.clientWidth);
    this.$store.commit("window/changeHeight", document.body.clientHeight);
  },
};
</script>

<style>
body {
  margin: 0;
  padding: 0;
}
#app {
  font-family: -apple-system, BlinkMacSystemFont, 'Helvetica Neue', 'Helvetica', 'Arial','Microsoft JhengHei', 'sans-serif',
    'PingFang TC', 'Microsoft YaHei';
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
}
</style>
